
import request from "@/utils/request";

export default function agentGetAccessControlerDeviceByPage(params) {
    return request.get(`/device/accessControllerDevice/agentGetAccessControlerDeviceByPage`,{
        params
    })
}
